import { initials } from "@/utils/format";

interface AvatarProps {
  lastName: string;
  firstName: string;
  src?: string;
  size?: "sm" | "md" | "lg";
}

const sizes = { sm: "w-8 h-8 text-[11px]", md: "w-10 h-10 text-xs", lg: "w-14 h-14 text-sm" };

export default function Avatar({ lastName, firstName, src, size = "md" }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={`${firstName} ${lastName}`}
        title={`${firstName} ${lastName}`}
        className={`${sizes[size]} rounded-full object-top object-cover border border-background-200 shrink-0`}
      />
    );
  }
  return (
    <span
      className={`${sizes[size]} rounded-full bg-secondary-100 text-secondary-800 flex items-center justify-center font-semibold shrink-0`}
    >
      {initials(lastName, firstName)}
    </span>
  );
}